/****************************************************
 * Module Name:  lusterProxy.js
 * Project:      Pansuriya Impex Sales & Manufacturing
 * Owner:        info@pansuriyaimpex.com
 *
 * Copyright (c) Pansuriya Impex
 * All rights reserved.
 ****************************************************/
import restAPICall from "../../api/restAPICall";
import Constants from "../../constants";

export default class LusterProxy {
  static GetAllLuster = (callback) => {
    restAPICall(
      Constants.MANAGER_URL + "/luster",
      "get",
      Constants.userToken,
      undefined,
      undefined,
      undefined,
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };

  static GetSingleLuster = (lusterId, callback) => {
    let params = {
      id: lusterId,
    };

    restAPICall(
      Constants.MANAGER_URL + "/luster",
      "get",
      Constants.userToken,
      params,
      undefined,
      undefined,
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };

  static CheckLusterAvailable = (luster, callback) => {
    let params = {
      luster: luster,
    };

    restAPICall(
      Constants.MANAGER_URL + "/luster/available",
      "get",
      Constants.userToken,
      params,
      undefined,
      undefined,
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };

  static AddLuster = (luster, callback) => {
    restAPICall(
      Constants.MANAGER_URL + "/luster",
      "post",
      Constants.userToken,
      undefined,
      JSON.stringify(luster),
      "application/json",
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };

  static UpdateLuster = (luster, callback) => {
    restAPICall(
      Constants.MANAGER_URL + "/luster",
      "put",
      Constants.userToken,
      undefined,
      JSON.stringify(luster),
      "application/json",
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };

  static DeleteLuster = (luster, callback) => {
    restAPICall(
      Constants.MANAGER_URL + "/luster",
      "delete",
      Constants.userToken,
      undefined,
      JSON.stringify(luster),
      "application/json",
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };
}
